import React, {FC, useEffect, useRef, useState} from 'react'
import {Link, useHistory, useLocation} from 'react-router-dom'
import {apiErrorMessage} from '../../public/PublicModels'
import {connectGoogle} from './Api'
import {HR_CALENDAR_PATH} from './CalendarModel'

/** Google onayından dönüş: code ve state sunucuya gönderilir, ardından takvime dönülür */
const GoogleCallbackPage: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const [error, setError] = useState<string | null>(null)
  const sent = useRef(false)

  useEffect(() => {
    // StrictMode'da iki kez çalışmasın; Google kodu tek kullanımlık
    if (sent.current) return
    sent.current = true
    const params = new URLSearchParams(location.search)
    const code = params.get('code')
    const state = params.get('state')
    if (params.get('error') || !code || !state) {
      setError('Google bağlantısına izin verilmedi.')
      return
    }
    connectGoogle(code, state)
      .then(() => history.replace(`${HR_CALENDAR_PATH}?google=connected`))
      .catch((err) => setError(apiErrorMessage(err, 'Google hesabı bağlanamadı.')))
  }, [location.search, history])

  return (
    <div className='card'>
      <div className='card-body text-center py-20'>
        {error ? (
          <>
            <i className='bi bi-x-circle fs-3x text-danger d-block mb-4'></i>
            <div className='fs-5 fw-semibold mb-6'>{error}</div>
            <Link to={HR_CALENDAR_PATH} className='btn btn-light'>
              Takvime Dön
            </Link>
          </>
        ) : (
          <>
            <span className='spinner-border text-primary mb-4' />
            <div className='fs-5'>Google hesabınız bağlanıyor...</div>
          </>
        )}
      </div>
    </div>
  )
}

export {GoogleCallbackPage}
